import React, { createContext, useContext } from "react";

export const useTestEndpoints = () => {
  const fetchGreetings = async () => {
    try {
      const response = await fetch("http://52.14.60.29:3000/greetings", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok) throw new Error("Error fetching greetings.");

      const data = await response.json();
      console.log("Fetched Greetings:", data);
      return data;
    } catch (error) {
      console.error("Error fetching greetings:", error);
      return [];
    }
  };

  return {
    fetchGreetings,
  };
};

const TestEndpointsContext = createContext(null);

export const TestEndpointsProvider = ({ children }) => {
  const testEndpoints = useTestEndpoints();

  return (
    <TestEndpointsContext.Provider value={testEndpoints}>
      {children}
    </TestEndpointsContext.Provider>
  );
};

export const useTestEndpointsContext = () => useContext(TestEndpointsContext);
